import BaseReportTableModel from '../common/base-report-table-model'
import ScorecardReportDataExtractor from './scorecard-report-data-extractor'

/**
 * The model representing the report table for scorecard report.  This
 * class is responsible for taking data from the data model of a report report
 * and building the necessary metadata to populate the table created from table.js
 */
const ScorecardReportTableModel = BaseReportTableModel.extend({

	_drilldownSection: function() {
		return 'scorecards'
	},

	dataExtractor: function() {
		return new ScorecardReportDataExtractor(this.model)
	}

})

export default ScorecardReportTableModel
ScorecardReportTableModel.__filename__ = 'reports/scorecard-report/scorecard-report-table-model.js'
